// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"604de072","240":"78610f1b","491":"838e877f","562":"68c3ae0d","743":"f1dc76dc","879":"f2a91e5e","990":"c77a210d"}[chunkId] + ".chunk.js";
};